<template>
  <!-- 快捷菜单 -->
  <div>
    <div class="menu mvcenter" id="gjl">
      <div id="home">
        <input :checked="false" class="menu-btn mvcenter" id="menubtn" type="checkbox" />
        <label for="menubtn">
          <a-icon type="thunderbolt" class="iconfont icon-caidan" width="2em" height="2em" />
          <a-icon type="up-circle" class="iconfont icon-quxiaoguanbi1" />
        </label>
        <ul class="menu-list">
          <li class="mvcenter menu-item" v-for="(item,index) in lisObjText" :key="index">
            <a class="iconfont icon-lianxi">
              <a-tooltip>
                <template slot="title">{{item.text}}</template>
                <img
                  :src="getUrl(item.icon)"
                  @click="iconClickTo(item.url)"
                  style="width: 30px;height:30px;"
                />
                <!-- <a-icon :type="item.icon" @click="iconClickTo(item.url)" theme="filled" style="fontSize: 26px;" /> -->
              </a-tooltip>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import db from '@/utils/localstorage'
export default {
  data () {
    return {
      menuData: [],
      dbBgColor: db.get('COLOR')[0],
      lisObjText: [
        // {
        //   icon: 'check-circle',
        //   text: '审批',
        //   url: 'system/notice1'
        // },
        // {
        //   icon: 'pie-chart',
        //   text: '图表',
        //   url: ''
        // },
        // {
        //   icon: 'exclamation-circle',
        //   text: '统计',
        //   url: ''
        // },
        // {
        //   icon: 'calendar',
        //   text: '表单',
        //   url: ''
        // },
        // {
        //   icon: 'bell',
        //   text: '加粗',
        //   url: ''
        // },
        // {
        //   icon: 'car',
        //   text: '汽车',
        //   url: ''
        // }
      ]

    }
  },
  watch: {
    '$store.state.setting.color': {
      // 深度监听，可监听到对象、数组的变化
      handler (val, oldVal) {
        if (this.dbBgColor !== val[0]) {
          console.log('监听-系统颜色被修改', val, oldVal)
          this.setColor(val[0])
        }
      },
      deep: true // true 深度监听
    }
  },
  mounted () {
    this.setColor(this.dbBgColor)
    this.getMenu()
    this.$nextTick(() => {
      // 1.鼠标按下时的时候 获得鼠标坐标。 和鼠标在盒子里面的坐标， 然后用鼠标移动的时候坐标减去鼠标在盒子里面的坐标， 等于盒子的left跟top值
      var title = document.getElementById('gjl')
      var home = document.getElementById('home')
      title.addEventListener('mousedown', function (e) {
        var x = e.pageX - home.offsetLeft
        var y = e.pageY - home.offsetTop
        document.addEventListener('mousemove', move)
        function move (e) {
          home.style.left = e.pageX - x + 'px'
          home.style.top = e.pageY - y + 'px'
        }
        // 2 鼠标弹起，就让鼠标移动事件移除
        document.addEventListener('mouseup', function () {
          document.removeEventListener('mousemove', move)
        })
      })
    })
  },
  methods: {
    getUrl (icon) {
      if (icon) {
        if (icon.includes('.png')) {
          return require(`../../../static/icon/${icon}`)
        } else {
          return icon
        }
      } else {
        return icon
      }
    },
    getMenu () {
      this.lisObjText = []
      // 3928017485
      this.$get('role', { roleId: db.get('USER').roleId }).then((res) => {
        if (res.data.rows[0].quickMenu) {
          let resData = JSON.parse(res.data.rows[0].quickMenu)
          if (resData.length > 6) {
            // 快捷菜单只截取前6个
            for (let k = 0; k < 6; k++) {
              this.lisObjText.push({
                icon: resData[k].icon,
                text: resData[k].menuName,
                url: resData[k].path
              })
            }
          } else {
            resData.forEach(element => {
              this.lisObjText.push({
                icon: element.icon,
                text: element.menuName,
                url: element.path
              })
            })
          }
        }
      })
    },
    setColor (colorVal) {
      if (colorVal && colorVal.includes('rgb')) {
        let bgColor2 = `rgb(${this.getSymbolText(colorVal)}, 0.2)`
        document.documentElement.style.setProperty('--BgColor', colorVal)
        document.documentElement.style.setProperty('--BgColor2', bgColor2)
      }
    },
    getSymbolText (str) {
      // 使用正则表达式匹配小括号内的内容
      const regex = /\((.*?)\)/g // 使用非贪婪模式匹配
      const matches = str.match(regex)
      return matches.map(match => match.replace(/\(|\)/g, ''))
    },
    iconClickTo (url) {
      this.$router.push(url)
    }
  }

}
</script>

<style lang="less" scoped>
/* 工具栏*/
#gjl {
  position: absolute;
  z-index: 999999;
  top: -250px;
  right: 21%;
}
#home {
  height: auto;
  position: absolute;
  cursor: pointer;
  /deep/ svg {
    font-size: 30px !important;
  }
}
body,
ul,
li,
input,
div {
  padding: 0;
  margin: 0;
}
body {
  overflow: hidden;
}
i {
  font-style: normal;
}
.mvcenter {
  position: absolute;
  top: 400px;
  right: 400px;
}
// .menu-btn.mvcenter{margin-top: -20px;margin-left:-20px;}
.menu-btn {
  width: 40px;
  height: 40px;
  cursor: pointer;
  background-color: red;
  border-radius: 20px;
  display: block;
  z-index: 99;
  opacity: 0;
  position: absolute;
  top: 400px;
  left: 280px;
}
.menu-btn + label {
  display: block;
  transition: transform 0.5s, top 0.5s;
  position: absolute;
  bottom: 0;
  right: 0;
  margin: auto;
  z-index: 99;
  cursor: pointer;
}
.menu-btn + label i {
  color: #fff;
  font-size: 30px;
  position: absolute;
  top: 404px;
  left: 285px;
  z-index: 12;
}
.menu-btn + label i.icon-caidan,
.menu-btn:checked + label i.icon-quxiaoguanbi1 {
  opacity: 1;
}
.menu-btn + label i.icon-quxiaoguanbi1,
.menu-btn:checked + label i.icon-caidan {
  opacity: 0;
}
.menu-btn:checked + label + .menu-list::after {
  opacity: 1;
}
.menu-btn + label::after {
  content: '';
  width: 60px;
  height: 60px;
  background-color: var(--BgColor);
  position: absolute;
  top: 390px;
  left: 270px;
  border-radius: 50%;
  z-index: 9;
}

.menu-list::after {
  content: '';
  width: 160px;
  height: 160px;
  background-color: var(--BgColor2);
  position: absolute;
  top: 340px;
  left: 220px;
  border-radius: 50%;
  z-index: 9;
  opacity: 0;
  transition: opacity 0.5s;
}
.menu-list > li.mvcenter {
  margin-top: 28px;
  margin-right: -754px;
}
.menu-list > li {
  // width: 40px;
  // height: 40px;
  // border-radius: 80px;
  // border:3px solid #b880eb;
  color: #8a2be1;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.5s;
  transform-origin: center center;
  z-index: 12;
}
.menu-list > li:nth-child(1) {
  transform: rotate(0);
}
.menu-list > li:nth-child(2) {
  transform: rotate(-45deg);
}
.menu-list > li:nth-child(3) {
  transform: rotate(-90deg);
}

.menu-list > li a {
  font-size: 20px;
  font-weight: bold;
}
.menu-list > li:nth-child(1) a {
  transform: rotate(0);
}
.menu-list > li:nth-child(2) a {
  transform: rotate(-45deg);
}
.menu-list > li:nth-child(3) a {
  transform: rotate(-90deg);
}

.menu-btn:checked ~ ul .menu-item {
  opacity: 1;
}
.menu-btn:checked ~ ul .menu-item:nth-child(1) {
  transform: rotate(0) translateX(-64px) translateY(-92px);
}
.menu-btn:checked ~ ul .menu-item:nth-child(2) {
  transform: rotate(45deg) translateX(-94px) translateY(38px);
}
.menu-btn:checked ~ ul .menu-item:nth-child(3) {
  transform: rotate(90deg) translateX(10px) translateY(62px);
}
.menu-btn:checked ~ ul .menu-item:nth-child(4) {
  transform: rotate(0) translateX(-9px) translateY(9px);
}
.menu-btn:checked ~ ul .menu-item:nth-child(5) {
  transform: rotate(0) translateX(16px) translateY(-40px);
}
.menu-btn:checked ~ ul .menu-item:nth-child(6) {
  transform: rotate(0) translateX(-12px) translateY(-92px);
}
</style>



// WEBPACK FOOTER //
// src/views/common/fastMenu.vue